import { Subject } from 'rxjs';

import { ISidebarTogglingData, ISidebarEmissionDataBase } from '../types';

export const anySidebarRecentTogglingData$ = new Subject<ISidebarTogglingData>();
export const forgetSidebarRememberedToBeOpenedAutomatically$ = new Subject<ISidebarEmissionDataBase>();
